import { render, staticRenderFns } from "./BatchTransferManager.template.vue?vue&type=template&id=60e7e7d7&scoped=true&"
var script = {}
import style0 from "./BatchTransferManager.template.vue?vue&type=style&index=0&id=60e7e7d7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7e7d7",
  null
  
)

export default component.exports